<div class="search-widget">
  <div lgContainer>
    <div lgRow>
      <div
        [lgColMdOffset]="lgColMdOffset"
        [lgColMd]="lgColMd"
        [lgColSmOffset]="lgColSmOffset"
        [lgColSm]="lgColSm"
      >
        @if (title) {
          <div
            [innerHTML]="title | safeHtml"
            [wysiwygContainer]="'Search Component'"
            class="search-widget__title lg-font--expressive lg-font-size-4--medium wysiwyg"
            dotcomFrontendWysiwyg
          ></div>
        }

        <lg-input-field [showLabel]="false">
          {{ placeholder }}
          <input
            (keyup.enter)="search()"
            [(ngModel)]="searchTerm"
            [placeholder]="placeholder"
            lgInput
          />
          <button
            (click)="search()"
            [iconButton]="true"
            [loading]="loading"
            aria-label="search"
            lg-button
            lgSuffix
            size="sm"
          >
            <lg-icon name="search"></lg-icon>
          </button>
        </lg-input-field>
      </div>
    </div>
  </div>
</div>
